<template>
  <div class="overlay-container" :class="{ 'wall-expanded': expanded }">
    <div class="photo-overlay" @click="showSelfie()">
      <v-btn v-if="canShare" color="white" class="photo-actions" x-small light fab @click="share()">
        <v-icon>mdi-share</v-icon>
      </v-btn>
      <ShareButton :selfie="selfie" />
      <h4>{{ selfie.title }}</h4>
      <p v-if="challengePerformance" class="ma-0">
        {{ challengePerformance }}
      </p>
      <p v-else-if="!!distance" class="ma-0">{{ distance }} m</p>
      <div v-if="teamName" class="team-section mt-2">
        <v-img v-if="teamLogo" :src="teamLogo || ''" class="team-logo-img" contain max-height="50px" max-width="80px">
        </v-img>
      </div>
    </div>
    <v-img
      :src="selfie.content_html ? selfie.content_html : selfie.image"
      v-bind:height="expanded ? '200px' : '80px'"
      v-bind:width="expanded ? '200px' : '80px'"
    ></v-img>
    <v-dialog v-model="selfieEnlarge" :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <v-btn color="white" class="dialog-close-btn" x-small light fab @click="selfieEnlarge = false">
          <v-icon large>mdi-close</v-icon>
        </v-btn>
        <v-row style="height: 90vh" class="ma-0" no-gutters>
          <v-col cols="12" md="9" style="background: #333">
            <ShareButton :selfie="selfie" />
            <div class="d-flex fill-height flex-column justify-center">
              <img class="single-image" v-bind:src="selfie.image" />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-container>
              <h3>
                {{ selfie.title }}
              </h3>
              <p class="caption ma-0" v-if="selfie.step">{{ selfie.step }}</p>

              <p class="ma-0" v-if="challengePerformance">
                {{ challengePerformance }}
              </p>
              <p class="overline ma-0" v-else-if="!!distance">{{ distance }} m</p>
              <div v-if="teamName" class="team-section mt-2">
                <v-img
                  v-if="teamLogo"
                  :src="teamLogo || ''"
                  contain
                  max-height="50px"
                  max-width="100px"
                  :alt="teamName"
                  :title="teamName"
                >
                </v-img>
                <span v-else>{{ teamName }}</span>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ShareButton from "../../participant/components/share_button";

export default {
  name: "WallEntry",
  props: {
    selfie: null,
    pHashtag: String,
    expanded: {
      type: Boolean,
    },
  },
  components: {
    ShareButton,
  },
  data() {
    return {
      selfieEnlarge: false,
    };
  },
  methods: {
    share() {
      navigator.share({
        title: "MDN",
        text: "Learn web development on MDN!",
        url: "https://developer.mozilla.org",
      });
    },
    showSelfie() {
      this.selfieEnlarge = true;
    },
    getSelfieTagValue(tagName) {
      let tags = this.selfie.tags;
      if (tags.length < 1) return null;

      let value = tags.find((tag) => tag.startsWith(tagName));
      if (!value) return null;

      return value.replace(tagName + "_", "");
    },
  },
  computed: {
    distance() {
      return Number(this.getSelfieTagValue("DISTANCE"));
    },
    challengePerformance() {
      return this.getSelfieTagValue("CHALLENGE_PERFORMANCE");
    },
    teamName() {
      return this.getSelfieTagValue("TEAM_NAME");
    },
    teamLogo() {
      return this.getSelfieTagValue("TEAM_LOGO");
    },
    canShare() {
      return !!navigator.share;
    },
    hashtag() {
      let hash = this.$route.query.hashtag;
      if (!hash) return "";
      if (!!hash && hash[0] === "#") {
        hash = hash.substr(1);
      }
      return hash.toUpperCase();
    },
  },
};
</script>

<style scoped lang="scss">
.team-logo-img {
  margin-left: auto;
  margin-right: auto;
}

.photo-overlay {
  opacity: 0;
  z-index: 1;
  transition: opacity 100ms;
  position: absolute;
  width: 100%;
  max-width: 50px;
  max-height: 50px;
  height: 100%;
  top: 0;
  left: 0;
  background: #444444c0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  letter-spacing: 1px;
  color: white;
  font-size: 0.8em;
  font-weight: 400;
  text-shadow: 1px 1px black;
  cursor: pointer;

  .photo-actions {
    position: absolute;
    top: 5px;
    left: 5px;
  }
}
.photo-actions-on-photo {
  position: absolute;
  top: 15px;
  left: 15px;
}
.overlay-container {
  position: relative;
  max-width: 80px;
  max-height: 80px;
  &:hover {
    .photo-overlay {
      opacity: 1;
    }
  }
}
.dialog-close-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
.wall-expanded {
  .photo-overlay {
    max-width: 200px !important;
    max-height: 200px !important;
  }
  &.overlay-container {
    max-width: 200px !important;
    max-height: 200px !important;
  }
}

.single-image {
  max-height: 80vh;
  max-width: 100%;
  margin: 0 auto;
  display: block;
}
</style>
